import React from 'react';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { AlertCircleIcon, LockIcon } from 'lucide-react';
interface StateScreenProps {
  onAction: () => void;
}
export function SessionExpiredScreen({
  onAction
}: StateScreenProps) {
  return <div className="min-h-screen flex items-center justify-center p-4 bg-navy" data-id="element-767" data-mp="8gpjewyh0uhb">
      <Card className="w-full max-w-md p-8 text-center" data-id="element-768" data-mp="8elimnvvcbl9">
        <div className="w-12 h-12 bg-amber/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-769" data-mp="36zwfgo4e1gwv">
          <AlertCircleIcon className="w-6 h-6 text-amber" data-id="element-770" data-mp="3by7pozylhtfm" />
        </div>
        <h2 className="text-2xl font-serif text-white mb-2" data-id="element-771" data-mp="3gwhk38chwq06">
          Your session has expired
        </h2>
        <p className="text-gray-400 mb-8" data-id="element-772" data-mp="3loj4jhjthn1a">
          Please log in again to continue reviewing documents.
        </p>
        <Button fullWidth onClick={onAction} data-id="element-773" data-mp="2o7keo5tdunou">
          Log In Again
        </Button>
      </Card>
    </div>;
}
export function AccessDeniedScreen({
  onAction
}: StateScreenProps) {
  return <div className="min-h-screen flex items-center justify-center p-4 bg-navy" data-id="element-774" data-mp="1yukhlong355k">
      <Card className="w-full max-w-md p-8 text-center" data-id="element-775" data-mp="1txtzkvs2xzhi">
        <div className="w-12 h-12 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-776" data-mp="1tz55p28zzjbs">
          <LockIcon className="w-6 h-6 text-red-500" data-id="element-777" data-mp="1l4qq0ykk26s5" />
        </div>
        <h2 className="text-2xl font-serif text-white mb-2" data-id="element-778" data-mp="1l48njk7auwbs">
          You don't have access to this case
        </h2>
        <p className="text-gray-400 mb-8" data-id="element-779" data-mp="1g31g5m92jz5n">
          Contact your administrator to request access.
        </p>
        <Button fullWidth onClick={onAction} data-id="element-780" data-mp="166ycgbykjsgl">
          Back to Cases
        </Button>
      </Card>
    </div>;
}